export class ProcessingActivityProcessDTO {
    processingActivityId: number;
    
    processId: number;
    
    constructor(processingActivityId?: number, processId?: number) {
        this.processingActivityId = processingActivityId ?? -1;
        this.processId = processId ?? -1;
    }
}